import { Box, Button, CircularProgress, Typography, styled } from '@mui/material'
import { Check } from '@mui/icons-material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface BatchActionBarProps {
  selectedCount: number
  onPerformAll: () => void
  isPerforming?: boolean
  isSigning?: boolean
}

const BatchActionBar: FC<BatchActionBarProps> = ({
  selectedCount,
  onPerformAll,
  isPerforming,
  isSigning = false,
}) => {
  const { t } = useTranslation(['maintenance', 'common'])

  if (selectedCount === 0) return null

  return (
    <StyledBar>
      <Typography variant="body2" fontWeight={600} sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>
        {selectedCount} {t('selected', { ns: 'common' })}
      </Typography>
      <Button
        variant="contained"
        size="small"
        color="primary"
        startIcon={isSigning ? <CircularProgress size={16} color="inherit" /> : <Check />}
        onClick={onPerformAll}
        disabled={isPerforming}
        sx={{ fontSize: { xs: '0.75rem', sm: '0.8125rem' }, px: { xs: 1, sm: 2 } }}
      >
        {t('sign-selected', { ns: 'maintenance' })}
      </Button>
    </StyledBar>
  )
}

export default BatchActionBar

const StyledBar = styled(Box)(({ theme }) => ({
  position: 'sticky',
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[4],
  zIndex: 10,
  [theme.breakpoints.down('sm')]: {
    padding: '10px 8px',
  },
}))
